<template>
  <div :class="{ 'item-service': true, 'is-open': isOpenProp }">
    <v-card
      :class="{ selected: selected }"
      @click.prevent="stateHandler"
      class="pt-12 pb-6 px-3 pt-md-10 pb-md-2 px-md-4 mx-3 mb-5 text-center card service item-service__container"
      outlined
      tile
      :style="`background-color: ${this.user.config.parameters.parameters.colorprimary}; color: ${this.user.config.parameters.parameters.colorbackground}`"
    >
      <div class="item-service__toolbar pt-2">
        <CommentIcon v-if="item.jobcomments" :primaryColor="'currentColor'" style="left: 5px; position: absolute" />
        <CheckedIcon
          v-if="selected"
          :primaryColor="this.user.config.parameters.parameters.selectedserviceiconcolor"
          :backgroundColor="this.user.config.parameters.parameters.colorbackground"
        />
        <CollapseIcon v-if="isOpenProp && !item.commentsaredisabled" :primaryColor="'currentColor'" @click="collapse()" />
      </div>

      <div class="item-service__inner">
        <div class="item-service__content">
          <p class="item-service__description pb-6 pb-md-2">{{ item.jobdescription }}</p>
          <transition name="fadeHeight" mode="out-in" :css="!item.commentsaredisabled">
            <p v-show="isOpenProp && item.jobextdescription" class="item-service__extdescription">{{ item.jobextdescription }}</p>
          </transition>
          <transition name="fadeHeight" mode="out-in" :css="!item.commentsaredisabled" v-if="!item.commentsaredisabled">
            <v-textarea
              v-if="isOpenProp"
              solo
              rows="3"
              name="jobcomments"
              auto-grow
              :label="placeholder"
              :single-line="true"
              counter="255"
              maxlength="255"
              v-model="item.jobcomments"
              @keydown="onKeyDown"
            ></v-textarea>
          </transition>
        </div>
        <div class="item-service__content item-service__content--last">
          <v-row no-gutters>
            <div class="col-6 text-left">
              <p v-if="this.user.config.parameters.parameters.servicestime" class="mb-0 item-service__time">
                <span v-if="this.item.jobtime != 0">~</span>{{ formattedTime }}
              </p>
              <p v-else class="mb-0 item-service__time">&nbsp;</p>
            </div>
            <div class="col-6 text-right">
              <span v-if="this.user.config.parameters.parameters.servicesprice && item.jobprice > 0" class="mb-0 item-service__priceContent">
                <label class="item-service__labelPriceFrom">{{ $t('general.words.from') }}:</label>
                <p>{{ item.jobprice }},-</p>
              </span>
              <span v-else class="mb-0 item-service__priceContent">
                <label class="item-service__labelPriceFrom">&nbsp;</label>
                <p>&nbsp;</p>
              </span>
            </div>
          </v-row>
          <transition name="fadeHeight" mode="out-in" :css="!item.commentsaredisabled">
            <v-btn
              v-if="isOpenProp && selected"
              @click.stop="emitToParent()"
              class="v-btn col-10 col-lg-8 v-btn--depressed px-14 v-btn--flat v-btn--outlined v-btn--rounded v-size--default mb-4 mt-2"
              :style="{ color: this.user.config.parameters.parameters.colorprimary }"
            >
              <span v-if="selected">{{ $t('button.deselect_service') }}</span>
            </v-btn>
          </transition>
          <transition name="fadeHeight" mode="out-in" :css="!item.commentsaredisabled">
            <v-btn
              v-if="isOpenProp && !selected"
              @click.stop="emitToParent()"
              class="v-btn col-10 col-lg-8 px-14 v-btn--rounded v-size--default mb-4 mt-2 v-btn v-btn--contained v-size--default"
              :style="{ color: this.user.config.parameters.parameters.colorprimary }"
            >
              <span v-if="!selected">{{ $t('button.select_service') }}</span>
            </v-btn>
          </transition>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
//TODO: implement better icon importing with one file to handle their exports
import CollapseIcon from '@/assets/images/collapseIcon.vue';
import CommentIcon from '@/assets/images/commentIcon.vue';
import CheckedIcon from '@/assets/images/checkedIcon.vue';

import localizationTexts from '@/localization/texts.json';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'ItemService',
  components: {
    CollapseIcon,
    CommentIcon,
    CheckedIcon
  },
  props: {
    item: Object,
    selected: Boolean,
    isOpenProp: Boolean
  },
  data() {
    return {
      placeholder: '',
      value: false,
      time: '',
      formattedTime: ''
    };
  },
  methods: {
    collapse() {
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'services',
        eventAction: 'service-show',
        serviceJobCode: this.item.jobcode,
        serviceJobDescription: this.item.jobdescription
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);
      this.$emit('stateOpenItemToParent', { item: this.item, state: false });
    },
    stateHandler() {
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'services',
        eventAction: 'service-hide',
        serviceJobCode: this.item.jobcode,
        serviceJobDescription: this.item.jobdescription
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);
      if (!this.isOpenProp) this.$emit('stateOpenItemToParent', { item: this.item, state: true });
    },
    emitToParent() {
      this.$emit('stateOpenItemToParent', { item: this.item, state: false });
      this.$emit('childToParent', this.item);
    },
    onKeyDown(evt) {
      if (evt.target.value == undefined) return;

      if (evt.target.value.length > 255) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      if (evt.target.value.length >= 255) {
        if ((evt.keyCode >= 48 && evt.keyCode <= 90) || (evt.keyCode >= 186 && evt.keyCode <= 222) || evt.keyCode == 13) {
          evt.preventDefault();
          return;
        }
      }
    }
  },
  computed: mapGetters(['user']),
  mounted() {
    this.value = false;
    if (this.user.services.length > 0) {
      const item = this.item;
      const filtered = this.user.services.filter(function (service) {
        return item.jobcode === service.jobcode;
      });
      if (filtered.length > 0) {
        this.value = true;
      }
    }
    this.formattedTime = helpers.formattedTime(this.item.jobtime, localizationTexts[this.user.config.language]);

    this.placeholder =
      this.item.specialplaceholdertextfortextarea ||
      localizationTexts[this.user.config.language].validation.placeholders.service_jobcomments_dialog_textarea;
  },
  updated() {
    if (this.user.services.length === 0) {
      this.value = false;
    }
  }
});
</script>
<style lang="scss">
$base-class: 'item-service';
.#{$base-class} {
  .v-textarea {
    .v-text-field__details .v-counter {
      color: white;
      font-size: 0.6em;
    }
    textarea {
      font-size: 1em;
    }
    .v-text-field__slot .v-label {
      font-size: 1em;
    }
  }
}
</style>
<style scoped lang="scss">
@import './src/assets/scss/_variables.scss';

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.2s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
}

$base-class: 'item-service';
.#{$base-class} {
  position: relative;
  display: block;

  .transition-height {
    height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
    height: auto;
    max-height: 0;
    &-show {
      max-height: 600px;
    }
  }

  &__inner {
    position: relative;
  }

  &__container {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      display: block;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
      transition: opacity 0.3s;
      border-radius: inherit;
    }
  }

  &__extdescription {
    font-size: 0.9em;
  }

  &__description {
    font-weight: 800;
    @media (min-width: 600px) {
      & {
        min-height: 60px;
        margin-top: 5px;
      }
    }
  }
  &.is-open {
    @media (min-width: 600px) {
      .#{$base-class}__description {
        min-height: auto;
      }
    }
  }

  &__time {
    font-size: 0.85rem;
    letter-spacing: 0.04em;
    font-weight: 800;
    padding: 6px 0;

    @media (min-width: 960px) {
      & {
        padding: 6px 0 0;
      }
    }
  }
  &__priceContent {
    display: -webkit-inline-box;
    font-weight: 800;

    p {
      font-size: 1rem;
      letter-spacing: 0.04em;
      font-weight: 800;
      margin-bottom: 5px;
    }
  }
  &__labelPriceFrom {
    font-size: 0.6875rem;
    margin-right: 8px;
  }

  &__button {
    z-index: 3;
    box-shadow: none;
    height: 34px;
    font-size: 0.6875rem;
    color: $lightest;
    border-color: $lightest;
  }

  &__toolbar {
    height: 22px;
    line-height: 22px;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    margin: 6px 6px;
    top: 0;
    font-weight: 700;
    font-size: 1.1rem;
    right: 0;
    z-index: 3;
    transform: translate(0, -3px);
    transition: transform 0.3s, opacity 0.3s;
    width: 100%;
  }

  &__content {
    position: relative;
    z-index: 2;

    .v-btn {
      background-color: #ffffff !important;
    }

    &--last {
      bottom: 0;
      left: 0;
      width: 100%;

      @media (min-width: 960px) {
        & {
          position: relative;
          bottom: 0;
          left: 0;
          width: 100%;
        }
      }
    }
  }

  .item-service__container.selected {
    box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);

    &::before {
      opacity: 0.5;
      background: $darkest;
    }

    .item-service {
      &__button {
        z-index: 3;
        color: currentColor;
        background-color: $lightest;
      }
    }
  }
}
</style>

<i18n src="../../localization/texts.json"></i18n>
